export default __webpack_public_path__ + "static/media/sn13.0d290a95.jpg";